<template>
  <div style="width: 100%; height: 100%;">
    <iframe style="width: 100%; height: 100%;" src="https://docs.google.com/document/d/e/2PACX-1vR1do95YiEZUl8YjEMD5TqsK2Ht3pWlPr71NdjGuf_PBTrr0A99lSIF9Ihx9foelfb-1mbOvSH0MCOq/pub?embedded=true"></iframe>
  </div>
</template>

<script>
export default {
  name: "BookingTnC"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BookingTnC.vue